import React from "react";
import { FranjaFija } from "./franjaFija";

// Banda oscura con el logo de la asociación (debajo de los sponsors)
export const BandaAsociacion = ({ idAsociacion, logo, nombre }) => {
  const src =
    idAsociacion && logo
      ? `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${idAsociacion}/IMAGENES/ASOCIACIONES/${logo}`
      : "/img/default-asociacion.svg";

  return (
    <FranjaFija izq="#061826">
      <div className="banda-asoc">
        <img src={src} alt={`Logo ${nombre || "asociación"}`} />
      </div>
    </FranjaFija>
  );
};
